import { Route, Routes } from 'react-router-dom';
import { NotFound } from '@l2u/ui/auth/NotFound.tsx';
import { LegacyPrefixRedirect } from '@l2u/ui/auth/LegacyPrefixRedirect.tsx';
import { CompanyLogin } from './auth/CompanyLogin.tsx';
import { CompanyLinkRedeem } from './auth/CompanyLinkRedeem.tsx';
import { CompanyCallback } from './auth/CompanyCallback.tsx';
import { CompanyExpired } from './auth/CompanyExpired.tsx';
import { CompanyShell } from './company/CompanyShell.tsx';
import { VendorMfaGate } from './company/VendorMfaGate.tsx';
import { CompanyHome } from './company/Home.tsx';
import { CompanyInformation } from './company/CompanyInfo.tsx';
import { Questionnaire } from './company/Questionnaire.tsx';
import { MyDocuments } from './company/MyDocuments.tsx';

export function App() {
  return (
    <Routes>
      {/* Auth */}
      <Route path="/login" element={<CompanyLogin />} />
      <Route path="/expired" element={<CompanyExpired />} />
      <Route path="/callback" element={<CompanyCallback />} />

      {/* Company */}
      {/* The 2FA gate wraps the shell rather than sitting inside it: the
          shell's queries fire on `enabled: !!session` whatever the component
          returns, so an inner guard would still call /api/me at aal1. See
          VendorMfaGate.tsx. */}
      <Route
        path="/"
        element={
          <VendorMfaGate>
            <CompanyShell />
          </VendorMfaGate>
        }
      >
        <Route index element={<CompanyHome />} />
        <Route path="info" element={<CompanyInformation />} />
        <Route path="questionnaire" element={<Questionnaire />} />
        <Route path="documents" element={<MyDocuments />} />
      </Route>

      {/* Root-level dynamic segment for redeeming an invite token. React Router
          ranks static segments above dynamic ones, so /login, /expired,
          /callback and the shell's static children win. Trade-off: an unknown
          single-segment URL now lands on the redeem page's invalid-token error
          instead of NotFound. */}
      <Route path="/:token" element={<CompanyLinkRedeem />} />

      {/* Legacy /c/* — already-sent vendor emails link /c/login, /c/{token},
          /c/callback. LegacyPrefixRedirect strips the prefix and preserves
          search + hash. */}
      <Route path="/c/*" element={<LegacyPrefixRedirect prefix="/c" />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
